

export function getPriMap() {

    const u = {
        provinceList: [
            {
                "code": "41",
                "name": "河南",
                "count": 0.0
            },
            {
                "code": "11",
                "name": "北京",
                "count": 0.0
            },
            {
                "code": "12",
                "name": "天津",
                "count": 0.0
            },
            {
                "code": "13",
                "name": "河北",
                "count": 0.0
            },
            {
                "code": "14",
                "name": "山西",
                "count": 0.0
            },
            {
                "code": "15",
                "name": "内蒙古",
                "count": 0.0
            },
            {
                "code": "21",
                "name": "辽宁",
                "count": 0.0
            },
            {
                "code": "22",
                "name": "吉林",
                "count": 0.0
            },
            {
                "code": "23",
                "name": "黑龙江",
                "count": 0.0
            },
            {
                "code": "31",
                "name": "上海",
                "count": 0.0
            },
            {
                "code": "32",
                "name": "江苏",
                "count": 0.0
            },
            {
                "code": "33",
                "name": "浙江",
                "count": 0.0
            },
            {
                "code": "34",
                "name": "安徽",
                "count": 0.0
            },
            {
                "code": "35",
                "name": "福建",
                "count": 0.0
            },
            {
                "code": "36",
                "name": "江西",
                "count": 0.0
            },
            {
                "code": "37",
                "name": "山东",
                "count": 0.0
            },
            {
                "code": "42",
                "name": "湖北",
                "count": 0.0
            },
            {
                "code": "43",
                "name": "湖南",
                "count": 0.0
            },
            {
                "code": "44",
                "name": "广东",
                "count": 0.0
            },
            {
                "code": "45",
                "name": "广西",
                "count": 0.0
            },
            {
                "code": "46",
                "name": "海南",
                "count": 0.0
            },
            {
                "code": "50",
                "name": "重庆",
                "count": 0.0
            },
            {
                "code": "51",
                "name": "四川",
                "count": 0.0
            },
            {
                "code": "52",
                "name": "贵州",
                "count": 0.0
            },
            {
                "code": "53",
                "name": "云南",
                "count": 0.0
            },
            {
                "code": "54",
                "name": "西藏",
                "count": 0.0
            },
            {
                "code": "61",
                "name": "陕西",
                "count": 0.0
            },
            {
                "code": "62",
                "name": "甘肃",
                "count": 0.0
            },
            {
                "code": "63",
                "name": "青海",
                "count": 0.0
            },
            {
                "code": "64",
                "name": "宁夏",
                "count": 0.0
            },
            {
                "code": "65",
                "name": "新疆",
                "count": 0.0
            },
            // {
            //     "code" : "",
            //     "name" : "台湾",
            //     "count" : 0.0
            // },
            // {
            //     "code" : "",
            //     "name" : "香港",
            //     "count" : 0.0
            // },
            // {
            //     "code" : "",
            //     "name" : "澳门",
            //     "count" : 0.0
            // }
        ],
        henanList: [
            {
                "code": "4101",
                "count": 0.0,
                "name": "郑州市"
            },
            {
                "code": "4102",
                "count": 0.0,
                "name": "开封市"
            },
            {
                "code": "4103",
                "count": 0.0,
                "name": "洛阳市"
            },
            {
                "code": "4104",
                "count": 0.0,
                "name": "平顶山市"
            },
            {
                "code": "4105",
                "count": 0.0,
                "name": "安阳市"
            },
            {
                "code": "4106",
                "count": 0.0,
                "name": "鹤壁市"
            },
            {
                "code": "4107",
                "count": 0.0,
                "name": "新乡市"
            },
            {
                "code": "4108",
                "count": 0.0,
                "name": "焦作市"
            },
            {
                "code": "4109",
                "count": 0.0,
                "name": "濮阳市"
            },
            {
                "code": "4110",
                "count": 0.0,
                "name": "许昌市"
            },
            {
                "code": "4111",
                "count": 0.0,
                "name": "漯河市"
            },
            {
                "code": "4112",
                "count": 0.0,
                "name": "三门峡市"
            },
            {
                "code": "4113",
                "count": 0.0,
                "name": "南阳市"
            },
            {
                "code": "4114",
                "count": 0.0,
                "name": "商丘市"
            },
            {
                "code": "4115",
                "count": 0.0,
                "name": "信阳市"
            },
            {
                "code": "4116",
                "count": 0.0,
                "name": "周口市"
            },
            {
                "code": "4117",
                "count": 0.0,
                "name": "驻马店市"
            },
            {
                "code": "4190",
                "count": 0.0,
                "name": "直管县级行政区"
            }
        ]
    }
    return u
}
